/**
 * ECA Solution - MOQ / MUL Auto Quantity Adjuster v3
 * Kalles Theme 3.0.1 compatible
 */

(function () {
  'use strict';

  function getConfig() {
    const wrapper = document.querySelector('[data-moq]');
    if (wrapper) {
      return {
        moq: parseInt(wrapper.dataset.moq) || 1,
        mul: parseInt(wrapper.dataset.mul) || 1,
      };
    }
    if (window.__eca_moq) {
      return {
        moq: parseInt(window.__eca_moq.moq) || 1,
        mul: parseInt(window.__eca_moq.mul) || 1,
      };
    }
    return null;
  }

  function roundUpToMul(value, mul) {
    if (mul <= 1) return value;
    return Math.ceil(value / mul) * mul;
  }

  function enforceConstraints(rawValue, moq, mul) {
    let val = parseInt(rawValue) || moq;
    if (val < moq) val = moq;
    val = roundUpToMul(val, mul);
    return val;
  }

  function showMoqBadge(moq, mul, qtyInput) {
    document.querySelectorAll('.eca-moq-badge').forEach(el => el.remove());

    const badge = document.createElement('div');
    badge.className = 'eca-moq-badge';
    badge.style.cssText = [
      'font-size:12px',
      'color:#555',
      'margin:8px 0 4px 0',
      'padding:6px 10px',
      'background:#f5f5f5',
      'border-left:3px solid #c00',
      'border-radius:0 4px 4px 0',
      'display:flex',
      'gap:12px',
      'align-items:center',
      'width:fit-content',
    ].join(';');
    badge.innerHTML =
      `<span>Min. order: <strong style="color:#222">${moq}</strong></span>` +
      `<span style="color:#ccc">|</span>` +
      `<span>Multiples of: <strong style="color:#222">${mul}</strong></span>`;

    // qty div 바로 아래에 삽입 (같은 줄 아님, 다음 줄)
    const qtyWrap = qtyInput.closest('.quantity');
    const flexWrap = qtyWrap ? qtyWrap.closest('.flex') : null;
    const insertTarget = flexWrap || (qtyWrap && qtyWrap.parentElement);
    if (insertTarget) {
      // flex wrap 바깥 다음 형제로 삽입
      insertTarget.insertAdjacentElement('afterend', badge);
    }
  }

  function overridePlusMinusButtons(qtyInput, moq, mul) {
    const qtyWrap = qtyInput.closest('.quantity');
    if (!qtyWrap) return;

    const plusBtn  = qtyWrap.querySelector('.plus');
    const minusBtn = qtyWrap.querySelector('.minus');

    if (plusBtn) {
      const newPlus = plusBtn.cloneNode(true);
      plusBtn.parentNode.replaceChild(newPlus, plusBtn);
      newPlus.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let current = enforceConstraints(qtyInput.value, moq, mul);
        qtyInput.value = current + mul;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      });
    }

    if (minusBtn) {
      const newMinus = minusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinus, minusBtn);
      newMinus.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let current = enforceConstraints(qtyInput.value, moq, mul);
        let next = current - mul;
        if (next < moq) next = moq;
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      });
    }
  }

  function attachInputValidation(qtyInput, moq, mul) {
    qtyInput.min   = moq;
    qtyInput.value = enforceConstraints(parseInt(qtyInput.value) || moq, moq, mul);
    qtyInput.addEventListener('change', function () {
      const corrected = enforceConstraints(this.value, moq, mul);
      if (parseInt(this.value) !== corrected) {
        this.value = corrected;
        this.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;
    const config = getConfig();
    if (!config) return;
    const { moq, mul } = config;
    if (moq <= 1 && mul <= 1) return;

    const qtySelectors = [
      'input[name="quantity"]',
      '.quantity__input',
      '.js-qty-input',
      '#Quantity',
      '[data-quantity-input]',
    ];
    let qtyInput = null;
    for (const sel of qtySelectors) {
      qtyInput = document.querySelector(sel);
      if (qtyInput) break;
    }
    if (!qtyInput) return;

    attachInputValidation(qtyInput, moq, mul);
    overridePlusMinusButtons(qtyInput, moq, mul);
    showMoqBadge(moq, mul, qtyInput);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('kalles:section:load', init);
  document.addEventListener('shopify:section:load', init);

})();
